<!--
 * @Author: wsx
 * @Date: 2022-01-16 14:50:36
 * @LastEditTime: 2022-02-14 11:14:11
 * @LastEditors: Please set LastEditors
 * @Description:iconfont 图标
-->
<template>
  <i
    class='iconfont'
    :class="icon"
    v-bind="$attrs"
    :style="{transform:`rotate(${rotate}deg)`,fontSize:`${fontSize}px`}"
  ></i>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs
} from 'vue';
export default defineComponent({
  name: 'HIcon',
  components: {},
  props: {
    icon: {
      type: String,
      default: ''
    },
    rotate: {
      type: [Number, String],
      default: 0
    },
    fontSize: {
      type: String
    }
  },
  setup(props) {
    const state = reactive({});
    const refData = toRefs(state);
    return { ...refData };
  }
});
</script>
<style  lang='scss' scoped >
.iconfont {
  margin: 0 2px;
}
</style>